import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Btn = styled.button`
	border: 2px solid #fff;
	color: #fff;
	padding: 0.9em 1.8em;
	cursor: pointer;
	font-weight: 600;

	&:focus {
		outline: 0;
	}
`

const Button = ({ className, click, children }) => (
  <Btn className={className} onClick={click}>{children}</Btn>
)

Button.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
  click: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default Button


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/Button.js